module.exports = __webpack_public_path__ + "static/pubconfoslo2018-6316128b0943a76e49d4461b81fd5c8a.jpeg";